import { render, staticRenderFns } from "./OurStory.vue?vue&type=template&id=46d4127e&scoped=true"
import script from "./OurStory.vue?vue&type=script&lang=js"
export * from "./OurStory.vue?vue&type=script&lang=js"
import style0 from "./OurStory.vue?vue&type=style&index=0&id=46d4127e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d4127e",
  null
  
)

export default component.exports